import useUser from './useUser';


function useUserLocaleTag() {

    const user = useUser();

    return user?.locale || null;
}


export default useUserLocaleTag;
